/**
 * Checkout Mercado Pago (Argentina, plan Basic / canal): URL final al hosted checkout.
 * No pasa por `/api/create-payment-intent` (eso es solo Stripe PaymentIntent).
 */

function trimEnv(...candidates: (string | undefined)[]): string {
  for (const c of candidates) {
    const t = typeof c === "string" ? c.trim() : "";
    if (t) return t;
  }
  return "";
}

/** URL completa MP si está configurada; legacy `VITE_MP_TELEGRAM_GROUP_LINK` solo si apunta a mercadopago.com. */
export function getMercadoPagoCheckoutBasicArUrl(): string {
  const primary = trimEnv(import.meta.env.VITE_MP_CHECKOUT_BASIC_AR as string | undefined);
  if (primary) return primary;
  const legacy = trimEnv(import.meta.env.VITE_MP_TELEGRAM_GROUP_LINK as string | undefined);
  if (legacy && /mercadopago\.com/i.test(legacy)) return legacy;
  return "";
}

/** URL completa MP para VIP Argentina (opcional). Si existe, prioriza MP sobre Stripe en AR para el flujo VIP. */
export function getMercadoPagoCheckoutVipArUrl(): string {
  const primary = trimEnv(import.meta.env.VITE_MP_CHECKOUT_VIP_AR as string | undefined);
  if (primary) return primary;
  return "";
}

/**
 * URL completa MP para VIP Argentina con descuento activo.
 * Cuando hay una oferta especial (specialOfferActive), se usa este checkout dedicado
 * con el precio ya configurado en MercadoPago. Si no está definida, cae al URL normal.
 */
export function getMercadoPagoCheckoutVipArDiscountUrl(): string {
  const discountUrl = trimEnv(import.meta.env.VITE_MP_CHECKOUT_VIP_DISCOUNT_AR as string | undefined);
  if (discountUrl) return discountUrl;
  return "";
}

/**
 * URL completa MP para Mejores Amigos (Instagram Close Friends, plan_tier="wp") en Argentina.
 * Se usa como fallback público cuando la API de suscripciones falla (token sin
 * permiso de Suscripciones, plan_id incorrecto en DB, etc). El visitante no necesita
 * autenticación: MP toma el email durante el checkout. No hay tracking de carrito
 * abandonado en este path, pero garantiza que el checkout NUNCA falla en producción.
 */
export function getMercadoPagoCheckoutWpArUrl(): string {
  const primary = trimEnv(import.meta.env.VITE_MP_CHECKOUT_WP_AR as string | undefined);
  if (primary) return primary;
  return "";
}

/**
 * URL completa MP para el plan Platinum / Membresía Exclusiva en Argentina.
 * Mismo criterio que las otras: fallback público sin token cuando la API falla.
 */
export function getMercadoPagoCheckoutPlatinumArUrl(): string {
  const primary = trimEnv(import.meta.env.VITE_MP_CHECKOUT_PLATINUM_AR as string | undefined);
  if (primary) return primary;
  return "";
}
